'use client';
import './styles/default.scss';
import { useState } from 'react';
import { DailyJackpotsDebug } from './debug-menu.jackpots';
import { GlobalContextDebug } from './debug-menu.global-context';
import { WebVitalsDebug } from './debug-menu.web-vitals';
import { classes } from '@/utils/classes/classes';

/**
 * Debug Menu Component (Development Only)
 *
 * Floating panel for debugging features:
 * - Web Vitals monitoring controls
 * - Daily Jackpots debugging
 * - Global (Server) context snapshot
 *
 * Positioned above the navigation bar (60px from bottom)
 */
export const DebugMenu = () => {
    const [isOpen, setIsOpen] = useState(false);
    const [isMinimized, setIsMinimized] = useState(false);

    const handleToggle = () => {
        setIsOpen(true);
        setIsMinimized(false);
    };

    const handleMinimize = () => {
        setIsMinimized(!isMinimized);
    };

    const handleClose = () => {
        setIsOpen(false);
        setIsMinimized(false);
    };

    return (
        <>
            {!isOpen && !isMinimized && (
                <button className="debug-menu-toggle" onClick={handleToggle} title="Open Debug Menu">
                    🛠️
                </button>
            )}

            {(isOpen || isMinimized) && (
                <div className={classes('debug-menu-panel', isMinimized && 'minimized')}>
                    <div className="debug-menu-header">
                        <div className="debug-menu-title">
                            <span className="debug-menu-icon">🛠️</span>
                            <span>Debug Menu</span>
                            <span className="debug-menu-badge">DEV</span>
                        </div>
                        <div className="debug-menu-actions">
                            <button
                                className="debug-menu-btn minimize"
                                onClick={handleMinimize}
                                title={isMinimized ? 'Expand' : 'Minimize'}>
                                {isMinimized ? '□' : '−'}
                            </button>
                            <button className="debug-menu-btn close" onClick={handleClose} title="Close">
                                ×
                            </button>
                        </div>
                    </div>

                    {/* Content - only shown when not minimized */}
                    {!isMinimized && (
                        <div className="debug-menu-content">
                            <WebVitalsDebug />
                            <GlobalContextDebug />
                            <DailyJackpotsDebug />
                        </div>
                    )}

                    {isMinimized && (
                        <div className="debug-menu-minimized-hint" onClick={() => setIsMinimized(false)}>
                            Click to expand
                        </div>
                    )}
                </div>
            )}
        </>
    );
};
